import { isNil } from 'lodash';
import { getI18n } from 'react-i18next';

export const manageErrorResponse = (
  toastInstance: any | undefined,
  error: { status: number } | { response: {} } | string,
  customTitle?: string,
  bypassToast?: boolean,
) => {
  const { status, message, response, data = {} } = typeof error == 'string' ? JSON.parse(error) : error;

  const isOffline = !navigator.onLine;

  let title = isOffline
    ? 'Network error: You seem to be offline'
    : customTitle
      ? customTitle
      : data?.message
        ? data?.message
        : isNil(response)
          ? 'Backend error. No response was sent'
          : getI18n().t(`errors:general`);

  let redirectToErrorBoundary = false;
  //some errors we know they have to redirect to te error boundary because they are for data needed to display view
  if (bypassToast) {
    throw new Error(message ?? data?.message);
  }
  switch (status) {
    case 422:
      title = message ?? data?.message;
      break;
    case 400:
      title = message ?? data?.message;
      break;
    case 401:
    case 500:
      title = message ?? data?.message;
      break;
    case 403:
      title = message ?? data?.message;
      break;
    case 404:
      title = message ?? data?.message;
      break;
    case 429:
      title = getI18n().t(`errors:too_many_requests`, {
        defaultValue: `Status code 429 - There are too many requests at the moment. Please try again later`,
      });
      break;
    default:
      break;
  }
  if (redirectToErrorBoundary) {
    throw new Error(message ?? data?.message);
  } else {
    if (toastInstance) {
      return toastInstance({
        title: title,
        status: 'error',
        duration: 30000,
        isClosable: true,
        position: 'top',
      });
    }
  }
  return true;
};

export const defaultToastOptions = {
  duration: 8000,
  isClosable: true,
  position: 'top',
} as const;
